import { useAsync } from 'react-use-v13';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { QMShowProjectResponse } from '@scale/shared/qm/qmRequestTypes';

async function fetchQuery(projectId: string | undefined) {
  if (projectId) {
    return await apiFetch<QMShowProjectResponse>(null, `corp-api/qm/projects/${projectId}`, {
      method: 'GET',
    });
  }
}

export default function useQMProject(projectId: string | undefined, key: number = 0) {
  const state = useAsync(async () => fetchQuery(projectId), [projectId, key]);

  return {
    loading: state.loading,
    error: state.error,
    project: state.value,
  };
}
